jQuery(function ($) {
    // Use global shared function from main.js if available, otherwise fallback to local
    const loadValidationScript = window.loadValidationScript || function(callback) {
        if (window.InputValidator) {
            if (typeof callback === 'function') callback();
        } else if (window._validationScriptLoading) {
            const checkInterval = setInterval(function() {
                if (window.InputValidator) {
                    clearInterval(checkInterval);
                    delete window._validationScriptLoading;
                    if (typeof callback === 'function') callback();
                }
            }, 50);
        } else {
            window._validationScriptLoading = true;
            $.getScript("/assets/frontend/js/validation.js", function() {
                delete window._validationScriptLoading;
                if (typeof callback === 'function') callback();
            });
        }
    };
    
    loadValidationScript(function () {
        const cornerModalFormParent = $("body");

        // CORNER FORM MODAL SELECTIZE
        $('.corner-form-modal-selectize').selectize({
            plugins: ["clear_on_focus"],
            onChange: function (value) {

            }
        });
        // END CORNER FORM MODAL SELECTIZE

        // CORNER MODAL FORM
        let cornerModalForm = $(".corner-modal-form");
        let cornerModalFormPreloader = $(".corner-modal-form-preloader");
        let warningBoxCornerModalForm = $(".corner-modal-form-warning-messages");
        let inputCornerFormModalName = $(".corner-modal-form-input-warning-name");
        let messageCornerFormModalName = $(".corner-modal-form-message-warning-name");
        let inputCornerFormModalSurname = $(".corner-modal-form-input-warning-surname");
        let messageCornerFormModalSurname = $(".corner-modal-form-message-warning-surname");
        let inputCornerFormModalCode = $(".corner-modal-form-input-warning-code");
        let messageCornerFormModalCode = $(".corner-modal-form-message-warning-code");
        let inputCornerFormModalEmail = $(".corner-modal-form-input-warning-email");
        let messageCornerFormModalEmail = $(".corner-modal-form-message-warning-email");
        let inputCornerFormModalPhone = $(".corner-modal-form-input-warning-phone");
        let messageCornerFormModalPhone = $(".corner-modal-form-message-warning-phone");
        let inputCornerFormModalIncome = $(".corner-modal-form-input-warning-income");
        let messageCornerFormModalIncome = $(".corner-modal-form-message-warning-income");
        let inputCornerFormModalNonPolitic = $(".corner-modal-form-input-warning-non-politic");
        let messageCornerFormModalNonPolitic = $(".corner-modal-form-message-warning-non-politic");
        let inputCornerFormModalPrivacyPolicy = $(".corner-modal-form-input-warning-privacy-policy");
        let messageCornerFormModalPrivacyPolicy = $(".corner-modal-form-message-warning-privacy-policy");
        let cornerModalFormRunner = true;
        cornerModalFormParent.on("submit", ".corner-modal-form", function (e) {
            e.preventDefault();
            if (cornerModalFormRunner === true) {
                cornerModalFormRunner = false;
                let cornerModalFormInfo = cornerModalForm.serialize();
                cornerModalFormPreloader.addClass("preloader-visible");
                // $.ajax({
                //     url: "/wp-admin/admin-ajax.php",
                //     type: "post",
                //     data: {
                //         action: 'cornerModalFormFunc',
                //         cornerModalFormInfo: cornerModalFormInfo
                //     },
                //     dataType: 'json',
                //     success: function (response) {
                cornerModalFormRunner = true;
                let cornerModalFormChecker = 0;
                // let arrayForValidation = [
                //     {
                //         "key": response["form-corner-modal-name"],
                //         "path_input": inputCornerFormModalName,
                //         "path_message": messageCornerFormModalName
                //     },
                //     {
                //         "key": response["form-corner-modal-surname"],
                //         "path_input": inputCornerFormModalSurname,
                //         "path_message": messageCornerFormModalSurname
                //     },
                //     {
                //         "key": response["form-corner-modal-code"],
                //         "path_input": inputCornerFormModalCode,
                //         "path_message": messageCornerFormModalCode
                //     },
                //     {
                //         "key": response["form-corner-modal-email"],
                //         "path_input": inputCornerFormModalEmail,
                //         "path_message": messageCornerFormModalEmail
                //     },
                //     {
                //         "key": response["form-corner-modal-phone"],
                //         "path_input": inputCornerFormModalPhone,
                //         "path_message": messageCornerFormModalPhone
                //     },
                //     {
                //         "key": response["form-corner-modal-income"],
                //         "path_input": inputCornerFormModalIncome,
                //         "path_message": messageCornerFormModalIncome
                //     },
                //     {
                //         "key": response["form-corner-modal-non-politic"],
                //         "path_input": inputCornerFormModalNonPolitic,
                //         "path_message": messageCornerFormModalNonPolitic
                //     }
                //     {
                //         "key": response["form-corner-modal-privacy-policy"],
                //         "path_input": inputCornerFormModalPrivacyPolicy,
                //         "path_message": messageCornerFormModalPrivacyPolicy
                //     }
                // ];
                // for (let i = 0; i < arrayForValidation.length; i++) {
                //     cornerModalFormChecker = checkValidationFrontend(arrayForValidation[i].key, arrayForValidation[i].path_input, arrayForValidation[i].path_message, cornerModalFormChecker);
                // }
                cornerModalFormPreloader.removeClass("preloader-visible");
                if (cornerModalFormChecker === 0) {
                    $(".corner-form-modal-inner-container").remove();
                    $(".corner-form-modal-success-submit").removeClass("d-none");
                } else {
                    warningBoxCornerModalForm.show();
                }
                // }
                // });
            }
        });
        // END CORNER MODAL FORM

    });
});